import React, { useState } from 'react'
import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import ReportFooter from '../../ReportsFooter/ReportFooter'
import RotatingLinesLoader from '../../../../../../../components/_shared/Loaders/RotatingLinesLoader'
const CurrentUserReportTable = ({
    pageCount,
    isLoading,
    handleColumnSort,
    tableOptions,
    handleRowsPerPage,
    handlePageClick,
    data,
    downloadPDF,
    totaldata,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
    downloadExcel,
}) => {
    const [currentRow, setCurrentRow] = useState(null)
    const size = useWindowSize()
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">Current User Report</h1>

                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={data}
                    totaldata={totaldata}
                    mobileColumns={mobileColumns}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    handleRowsPerPage={handleRowsPerPage}
                    handleColumnSort={handleColumnSort}
                    removePagination={false}
                    handlePageClick={handlePageClick}
                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                     MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={data}
                    generatePDFFunction={downloadPDF}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">Current User Report</h1>
            {isLoading ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: '50vh' }}
                >
                    <RotatingLinesLoader />
                </div>
            ) : (
                <ReactDataTable
                    data={data}
                    columns={columns}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    totaldata={totaldata}
                    handleRowsPerPage={handleRowsPerPage}
                    removePagination={false}
                    handleColumnSort={handleColumnSort}
                    handlePageClick={handlePageClick}
                />
            )}
            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                 MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={data}
                generatePDFFunction={downloadPDF}
            />
        </>
    )
}

export default CurrentUserReportTable
